export default __webpack_public_path__ + "static/media/home_thumb_bsr.c040fa9e.png";